import ShadowsPanel from './shadows-panel';
import ShadowsEditPanel from './shadows-edit-panel';

export function ScreenShadows() {
	return <ShadowsPanel />;
}

export function ScreenShadowsEdit() {
	return <ShadowsEditPanel />;
}
